import { render, staticRenderFns } from "./shipCsv.vue?vue&type=template&id=a20c9db8&"
import script from "./shipCsv.vue?vue&type=script&lang=js&"
export * from "./shipCsv.vue?vue&type=script&lang=js&"
import style0 from "./shipCsv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports